import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { findProductFromProductId } from "@qgiv/p2p-registration";
import ProductLimitMessage from "./ProductLimitMessage";
import { selectCurrentProductId } from "../../../../redux/slices/productModalSlice";
import { selectAllProducts } from "../../../../redux/slices/productsSlice";
import { selectCmsControlByType } from "../../../../redux/slices/cmsSettingsSlice";

const ConnectedProductLimitMessage = ({ limitReached, overLimit }) => {
    const {
        ENUMS: {
            CMS_Control: { P2P_STORE_PRODUCTS },
        },
    } = constants;

    const currentProductId = useSelector(selectCurrentProductId);
    const products = useSelector(selectAllProducts);
    const product = findProductFromProductId(currentProductId, products);
    const { purchaseLimit } = product;

    const control = useSelector((state) =>
        selectCmsControlByType(P2P_STORE_PRODUCTS, state),
    );
    const {
        options: {
            purchaseLimitMessage = "Limit of %PurchaseLimit% per purchase",
        },
    } = control;

    const entityReplacedPurchaseLimitMessage =
        purchaseLimit && Number(purchaseLimit) > 0
            ? purchaseLimitMessage.replace("%PurchaseLimit%", purchaseLimit)
            : "";

    const displayQuantityInput = purchaseLimit !== 1;

    const productLimitMessageProps = {
        displayQuantityInput,
        entityReplacedPurchaseLimitMessage,
        limitReached,
        overLimit,
    };
    return <ProductLimitMessage {...productLimitMessageProps} />;
};

ConnectedProductLimitMessage.propTypes = {
    limitReached: PropTypes.bool.isRequired,
    overLimit: PropTypes.bool.isRequired,
};

export default ConnectedProductLimitMessage;
